namespace('arctic.views.groupLanding');

arctic.views.groupLanding.groupMemberEntry = function(viewport,options) {

	// starts measuring the time it takes for the view to load
	compass.startLoad('groupMemberEntryView');
	/*
	 * properties.
	 */
	var _viewport = viewport;
	var _d = jQuery.dom;
	var $j = jQuery;

	var _settings = options;
	var _greeting = {};

	var _divs = {};
	var _pageJSON = {};
	var me = this;

	/*
	 * self executing constructor.
	 */
	/*
	 * create the dom nodes of this view.
	 */
	var _render = function(d, data) {
		_greeting = data;

		if(data.group_id) {
			_divs.entryForm = d.div({ className : 'groupMemberEntry' },
					me.drawGroupMemberEntryGreeting(),
					me.drawSubmitButton()
			);
			_viewport.append(_divs.entryForm);
		} else {
			_viewport.append(d.div({ className : 'groupMemberEntry' },
				d.div({ className : 'errorMessage' },
					d.p('Oops! We can\'t find the group you\'re looking for.'),
					d.p('Please contact your group manager to verify the URL.')
				)
			));
		}
	};

	this.drawGroupMemberEntryGreeting = function() {
		var d = _d;
		return d.div({className:'groupMemberEntryGreeting'},
						d.pre({className:'messageText'}).text(_greeting.welcome_message.replace(/&amp;/g, "&"))
				);
	};

	//this is no longer being used in _render function
	this.drawEmailAddress = function() {
		var d = _d;
		return d.fieldLabelPair({
			className : 'email',
			label : 'Email address'
		}, [d.input({
			name : 'email',
			type : 'text',
			className : 'email groupMemberEmailInput',
			autocomplete: 'off'
		}), d.div({
			className : 'errorDiv emailRequired emailRequiredDiv'
		}, 'email address is required.')]);
	};
	//-------------------------------------------------


	this.drawSubmitButton = function() {
		var d = _d;
		return d.button({
			className : 'groupMemberEntryEnterButton button'
		},'Enter').activate(_submitGroupMemberEntry);
	};

	var _submitGroupMemberEntry = function() {
		var formData = {};

		formData.email = _viewport.find('.groupMemberEmailInput').val();
		formData.group_id = _pageJSON.group_id;

		$j.ajax({
			url: '/actGroupMemberEntry',
			data: formData,
			type: 'POST',
			success: function(data) {
				//do something
				_viewport.trigger(CompassEvents.Navigate, 'groupMemberRoomAssignment');
			}
		});
	};

	/*
	 * create the variuos widget objects and render their doms.
	 */
	var _setupWidgets = function(viewdata) { };
	/*
	 * setup all the controls.
	 */
	var _setupControls = function() { };

	this.run = function(renderComplete) {
		compass.loading.start();
		jQuery.ajax({
			url : '/groupMemberEntry',
			data: {
				"group_id": _settings.group_id
			},
			success : function(data) {
				compass.loading.stop();
				_pageJSON = data;
				_render(jQuery.dom, data);
				// move this into a renderer for testing.
				_setupWidgets(data);
				// draws the widgets and passes any rendering data into them.
				_setupControls();
				// sets up controls on the widgets. setups controls on the view itself.
				// stops measuring the time it takes the view to load
				compass.stopLoad('groupMemberEntryView');
				renderComplete();
			}
		});
	};
};

